import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitingPaymentCryptoComponent } from './waiting-payment-crypto.component';
import { DisabledInputModule } from '@app/core/components/disabled-input/disabled-input.module';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [WaitingPaymentCryptoComponent],
    exports: [WaitingPaymentCryptoComponent],
    imports: [CommonModule, MatButtonModule, DisabledInputModule, MatTabsModule, MatSelectModule, MatFormFieldModule, FormsModule]
})
export class WaitingPaymentCryptoModule {}
